module.exports = __webpack_public_path__ + "img/ozgur-atmaca-profile.cda77e4e.png";